export const SET_ACTIONS = Symbol();
export const RESET_ACTIONS = Symbol();
